/**
 * AIO-82885 — how the Skynet launcher is placed, for THIS source tree.
 *
 * `projects/desktop` and `projects/mobile` are separate apps with different chrome, but
 * skynet.service.ts and support-chat.service.ts are deliberately byte-identical copies (a shared
 * abstraction for ~100 lines of near-identical code would be worse than the copy, and the two
 * must not drift by hand). So the one thing that genuinely differs between them lives here, in a
 * file each tree has at the same `@core/services/` path with its own contents — the same
 * mechanism angular.json already uses for static-data.service.ts and dropdown-http.service.ts.
 *
 * NOT an environment value: both trees' environment.ts are replaced by the SAME per-brand file
 * (environments/<brand>/environment.prod.ts), so the environment cannot tell desktop from mobile.
 */

/**
 * Pixels between the launcher and the bottom of the viewport, passed to the widget's `init()`
 * as `bottomOffset` (guide v1.7 §5: an integer from 0 to 500).
 *
 * `null` means "send nothing", which leaves whatever a Skynet admin configured in their console
 * in charge. Prefer null over 0 — an explicit 0 would silently override that console setting.
 */
export const SKYNET_BOTTOM_OFFSET: number | null = null;
/*                                        ^ desktop has no fixed bottom bar, so the launcher sits
   where Skynet puts it and the console keeps control. */
